// @ts-nocheck
import { Table } from "antd";
import BaseComponent from "base/common/BaseComponent";
import styles from "./index.module.scss";
import "./antTableCustom.scss";

/**
 * ListTable - A component that renders data in a sortable and filterable table
 * @extends BaseComponent
 * @component
 * @param {Object} props
 * @param {Array} props.data - The data to display in the table
 * @param {Array} props.columns - Column configuration for the table
 * @param {number} props.tableWidth - The width of the table
 * @param {number} props.tableHeight - The height of the table
 * @param {Map} props.tableFilterMap - Mapping of filter keys to their corresponding column names
 * @param {Function} props.handleFilterSort - Callback function for handling filter and sort changes
 * @param {string} [props.testid] - Optional data-testid for the table container div
 * @param {Function} [props.rowTestId] - Optional callback (record) => string for per-row data-testid
 */
class ListTable extends BaseComponent {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  /**
   * Handles table filter and sort changes
   * @param {Object} pagination - Table pagination information
   * @param {Object} filters - Applied column filters
   * @param {Object} sorter - Applied column sorting
   */
  handleTableChange = (pagination: any, filters: any, sorter: any) => {
    const tableFilter = filters;
    const tableSorter = sorter;
    let filterArr: any[] = [];
    let sortArr = [];

    if (Object.values(tableFilter).some((value) => value !== null)) {
      filterArr = Object.entries(tableFilter)
        .filter(([key, value]) => value !== null)
        .map(([key, value]) => {
          return {
            filterColumn: this.props.tableFilterMap.get(key),
            filterValue: value,
          };
        });
    }

    if (Object.keys(tableSorter).length !== 0 && tableSorter.column !== undefined) {
      sortArr.push({
        sortColumn: tableSorter.column.sortName ?? tableSorter.column.dbName,
        isAscending: tableSorter.order === "ascend" ? true : false,
      });
    }

    this.props.handleFilterSort(filterArr, sortArr, filters);
  };

  render() {
    const {
      data,
      columns,
      tableHeight,
      rowSelection,
      rowKey,
      className,
      style,
      testid,
      rowTestId,
    } = this.props;

    const filteredColumns = columns.filter((column: any) => !column.hidden);

    return (
      <div className={styles.tableDiv} data-testid={testid}>
        {/* @ts-ignore */}
        <Table
          columns={filteredColumns}
          rowKey={rowKey ?? this._generateGUID()}
          dataSource={data}
          pagination={false}
          onChange={this.handleTableChange}
          rowSelection={rowSelection}
          scroll={{
            y: tableHeight,
          }}
          rowClassName={(record) => (record.isHighlight ? "high-light" : "")}
          className={className}
          style={style}
          onRow={rowTestId ? (record) => ({ "data-testid": rowTestId(record) }) : undefined}
        />
      </div>
    );
  }
}

export default ListTable;
